import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import QRCode from 'qrcode';
import { formatDateYear } from '@/utils/func'
import store from '@/store'

async function generateQRCode(text) {
    try {
        const base64 = await QRCode.toDataURL(text, {
            width: 150, // 二维码宽度（像素）
            margin: 1, // 边距
            color: {
                dark: '#000000', // 二维码颜色
                light: '#FFFFFF' // 背景色
            }
        });
        return base64;
    } catch (error) {
        console.error('生成二维码失败', error);
        return '';
    }
}
function generateBarcode2(text) {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, text, {
        format: 'CODE128',
        displayValue: false,
        height: 57,
        width: 2,
    });
    return canvas.toDataURL('image/png');
}
function generateBarcode(text) {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, text, {
        format: 'CODE128',
        displayValue: false,
        // height: 30,          // 缩小条码整体高度
        // width: 1.5,          // 缩细条码线条
        margin: 10,           // 统一边距为2px
        // marginTop: 5,        // 取消顶部默认边距
        // marginBottom: 5,     // 取消底部默认边距
        lineColor: '#000000',// 确保黑白对比度
        background: '#ffffff'// 纯色背景减少干扰
    });
    return canvas.toDataURL('image/png');
}
export async function exportExcel(navObj, titleList, rows, fileName) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();
    // 页面布局配置（关键优化部分）
    worksheet.pageSetup = {
        paperSize: 9,          // A4纸张[3,4](@ref)
        orientation: 'portrait',// 纵向布局
        fitToPage: true,       // 启用自适应页面
        fitToWidth: 1,         // 适应1页宽度
        fitToHeight: 0,        // 高度不限
        horizontalCentered: true, // 水平居中
        verticalCentered: false,
        margins: {             // 缩小后的页边距[3](@ref)
            left: 0.2,
            right: 0.2,
            top: 0.4,
            bottom: 0.2,
            header: 0.2,
            footer: 0.2
        },
        showGridLines: false,  // 隐藏网格线
        blackAndWhite: false   // 彩色打印
    };

    // 页眉页脚配置（右上角显示页码）
    worksheet.headerFooter = {
        oddHeader: `&L零部件外发加工送货单${navObj.formCode}&R第&P页/共&N页`, // 右对齐单据编号
        // oddFooter: `&L零部件外发加工送货单${navObj.formCode}&R第&P页/共&N页`, // 右对齐页码
        evenHeader: `&L零部件外发加工送货单${navObj.formCode}&R第&P页/共&N页`,
        // evenFooter: `&L零部件外发加工送货单${navObj.formCode}&R第&P页/共&N页`,
        firstHeader: `&L零部件外发加工送货单${navObj.formCode}&R第&P页/共&N页`,
        // firstFooter: `&L零部件外发加工送货单${navObj.formCode}&R第&P页/共&N页`
    };

    worksheet.addRow(['零部件发外加工送货单']);
    worksheet.addRow([`单号：${navObj.formCode}`, '', `合同号：${navObj.project?.trackNumber}`, '']);
    worksheet.addRow([`加工商：${navObj.procSupplier?.supplierName}`, '', `收货单位：${store.state.companyId == 'LFWZ' ? '广东凌丰五金装备科技股份有限公司' :store.state.companyId == 'NTLD' ? '南通立德装备科技有限公司' : ''}`]);
    worksheet.addRow([`发货时间：${formatDateYear(navObj.auditTime)}`, '', `项目名称：${navObj.projectName}`, '']);
    // worksheet.addRow([`项目名称：${navObj.projectName}`, '','','' ]);
    worksheet.addRow(titleList);
    if (rows.length > 0) {
        rows.forEach(row => worksheet.addRow(row));
    }
    worksheet.addRow(['合计', '', '', '', '', `${navObj.sumQuantity}`, '', `${parseFloat((navObj.sumTotalPrice).toFixed(3))}`]);
    worksheet.addRow(['发货人：                           送货人：                                  签收：            ']);
    worksheet.eachRow({ startingRow: 1 }, function (row) {
        row.height = 22; // 设置除第一行以外的所有行的行高为20
    });

    // 获取工作表的实际数据范围（行数和列数）
    const rowCount = worksheet.rowCount;
    const columnCount = worksheet.columnCount;
    // 遍历所有行和列（包括空单元格）
    for (let rowNumber = 1; rowNumber <= rowCount; rowNumber++) {
        const row = worksheet.getRow(rowNumber);

        for (let colNumber = 1; colNumber <= columnCount; colNumber++) {
            // 获取或创建单元格（即使为空）
            const cell = row.getCell(colNumber);

            // 设置单元格样式
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
            cell.font = { family: '思源黑体', size: '11px' };
            // cell.style = {
            //     ...cell.style,
            //     wrapText: true
            // }
        }
    }
    // worksheet.getCell('K5').alignment.horizontal = 'left'
    worksheet.getColumn(1).width = 10.75
    worksheet.getColumn(2).width = 18
    worksheet.getColumn(3).width = 19
    worksheet.getColumn(4).width = 24
    worksheet.getColumn(5).width = 18
    worksheet.getColumn(6).width = 10.5
    worksheet.getColumn(7).width = 8.5
    worksheet.getColumn(8).width = 9

    // const base64Image = await generateQRCode(navObj.formCode);
    const base64Image = generateBarcode(navObj.formCode);
    const imageId = workbook.addImage({
        base64: base64Image,
        extension: 'png',
    });
    // worksheet.addImage(imageId, {
    //     tl: { col: 6, row: 0 },  // 左上角 (col, row) 索引从0开始
    //     ext: { width: 120, height: 120 },
    //     editAs: 'absolute'
    // });
    worksheet.addImage(imageId, {
        tl: { col: 4, row: 1 },  // 左上角 (col, row) 索引从0开始
        br: { col: 8, row: 4 },      // 右下角 (向右跨1列，向下跨1行)
        editAs: 'oneCell'                   // 随单元格移动
    });

    worksheet.mergeCells('A1:H1');
    worksheet.mergeCells('A2:B2');
    worksheet.mergeCells('C2:D2');
    worksheet.mergeCells('A3:B3');
    worksheet.mergeCells('C3:D3');
    // worksheet.mergeCells('E3:F3');
    worksheet.mergeCells('A4:B4');
    worksheet.mergeCells('C4:D4');
    // worksheet.mergeCells('D4:F4');
    // worksheet.mergeCells('G2:H4');
    worksheet.mergeCells(`A${6 + rows.length}:E${6 + rows.length}`);
    worksheet.mergeCells(`A${7 + rows.length}:H${7 + rows.length}`);
    worksheet.getRow(1).font = { bold: true, family: '思源黑体', size: '20px' };
    worksheet.getRow(1).height = 35;
    worksheet.getRow(5).font = { bold: true, family: '思源黑体', size: '11px' };
    worksheet.getRow(`${rows.length + 7}`).height = 30;

    // 列宽优化（根据内容自动调整）
    // worksheet.autoFitColumns({
    //     from: 1,
    //     to: worksheet.columnCount
    // });

    // 打印区域设置（确保所有列在一页）
    worksheet.printArea = {
        top: 1,
        left: 1,
        bottom: worksheet.rowCount,
        right: worksheet.columnCount
    };

    // 生成Excel文件
    const buffer = await workbook.xlsx.writeBuffer();

    // 创建Blob对象并保存文件
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // 使用FileSaver保存文件
    saveAs(blob, fileName);
}
export async function exportExcel2(titleList, rows, fileName) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();
    worksheet.addRow(titleList);
    if (rows.length > 0) {
        rows.forEach(row => worksheet.addRow(row));
    }

    // 获取工作表的实际数据范围（行数和列数）
    const rowCount = worksheet.rowCount;
    const columnCount = worksheet.columnCount;
    // 遍历所有行和列（包括空单元格）
    for (let rowNumber = 1; rowNumber <= rowCount; rowNumber++) {
        const row = worksheet.getRow(rowNumber);

        for (let colNumber = 1; colNumber <= columnCount; colNumber++) {
            // 获取或创建单元格（即使为空）
            const cell = row.getCell(colNumber);

            // 设置单元格样式
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
            cell.font = { family: '思源黑体', size: '11px' };
            // cell.style = {
            //     ...cell.style,
            //     wrapText: true
            // }
        }
    }
    worksheet.getColumn(1).width = 30
    worksheet.getColumn(2).width = 16
    worksheet.getColumn(3).width = 30
    worksheet.getColumn(4).width = 30
    worksheet.getColumn(5).width = 17
    worksheet.getColumn(6).width = 33
    worksheet.getColumn(7).width = 10
    // worksheet.getColumn(8).width = 8.5


    worksheet.getRow(1).font = { bold: true, family: '思源黑体', size: '16px' };
    worksheet.getRow(1).height = 25;
    worksheet.eachRow({ startingRow: 1 }, function (row) {
        row.height = 25; // 设置除第一行以外的所有行的行高
    });
    // 生成Excel文件
    const buffer = await workbook.xlsx.writeBuffer();

    // 创建Blob对象并保存文件
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // 使用FileSaver保存文件
    saveAs(blob, fileName);
}
export async function exportExcel3(titleList, rows, fileName) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet();
    worksheet.addRow(titleList);
    if (rows.length > 0) {
        rows.forEach(row => worksheet.addRow(row));
    }

    // 获取工作表的实际数据范围（行数和列数）
    const rowCount = worksheet.rowCount;
    const columnCount = worksheet.columnCount;
    // 遍历所有行和列（包括空单元格）
    for (let rowNumber = 1; rowNumber <= rowCount; rowNumber++) {
        const row = worksheet.getRow(rowNumber);

        for (let colNumber = 1; colNumber <= columnCount; colNumber++) {
            // 获取或创建单元格（即使为空）
            const cell = row.getCell(colNumber);

            // 设置单元格样式
            cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
            cell.font = { family: '思源黑体', size: '11px' };
            // cell.style = {
            //     ...cell.style,
            //     wrapText: true
            // }
        }
    }
    worksheet.getColumn(1).width = 18
    worksheet.getColumn(2).width = 31
    worksheet.getColumn(3).width = 10
    worksheet.getColumn(4).width = 18
    worksheet.getColumn(5).width = 27
    worksheet.getColumn(6).width = 20
    worksheet.getColumn(7).width = 20
    worksheet.getColumn(8).width = 20
    worksheet.getColumn(9).width = 9
    worksheet.getColumn(10).width = 13
    worksheet.getColumn(11).width = 14
    worksheet.getColumn(12).width = 23
    worksheet.getColumn(13).width = 23
    worksheet.getColumn(14).width = 13
    worksheet.getColumn(15).width = 13
    worksheet.getColumn(16).width = 8
    worksheet.getColumn(17).width = 18
    worksheet.getColumn(18).width = 21


    worksheet.getRow(1).font = { bold: true, family: '思源黑体', size: '14px' };
    worksheet.getRow(1).height = 25;
    worksheet.eachRow({ startingRow: 1 }, function (row) {
        row.height = 25; // 设置除第一行以外的所有行的行高
    });
    // 生成Excel文件
    const buffer = await workbook.xlsx.writeBuffer();

    // 创建Blob对象并保存文件
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // 使用FileSaver保存文件
    saveAs(blob, fileName);
}